import { useBaseApiMutation } from "@mutation/baseMutation";

export const useClubUpdateMutation = (club_uuid) => {
    return useBaseApiMutation({
        method: "PUT",
        endpoint: `/club/${club_uuid}`,
    });
};

export const useCreateClubEventMutation = () => {
    return useBaseApiMutation({
        method: "POST",
        endpoint: '/club/{clubUuid}/event/{eventUuid}',
    });
};

export const useClubEventUpdateMutation = () => {
    return useBaseApiMutation(
        {
            endpoint: '/club/{clubUuid}/clubEvent/{clubEventUuid}',
            method: "PUT"
        }
    );
};

export const useSendPointsToAccountMutation = () => {
    return useBaseApiMutation({
        method: "POST",
        endpoint: '/organization/me/club/{club_uuid}/send_points_to/{account_uuid}/amount/{amount}',
    });
};
